import { createApp, computed } from 'vue';
import App from './views/App.vue';
import router from './views/router/index';
import store from './store';

export { store };

import './style/main.scss';

const IS_DEBUG_ENABLED = process.env.VUE_APP_ENABLE_DEBUG === 'true';
const IS_USE_MOCK = process.env.VUE_APP_USE_MOCK === 'true';

IS_USE_MOCK && console.info('VITE_USE_MOCK');

if (!IS_DEBUG_ENABLED) {
  const emptyFunciton = () => {
    /* do nothing */
  };
  console.debug = emptyFunciton;
  console.info = emptyFunciton;
  console.log = emptyFunciton;
  console.warn = emptyFunciton;
  console.error = emptyFunciton;
  window.alert = emptyFunciton;
}

document.addEventListener('contextmenu', (event) => event.preventDefault());

const app = createApp(App);
app.use(store).use(router).mount('#app');

if (!window.closeWindow) {
  window.closeWindow = () => console.log('關閉地圖');
}

const mapName = computed(() => store.getters.getMapName());

router.afterEach((to) => {
  setTimeout(() => {
    if (typeof gtag == 'function') {
      if (to.name === 'home') {
        const url = location.href;
        const array = url.split('?')[1]?.split('&');
        let memberCode = '';
        array?.forEach((item) => {
          if (item.includes('m')) {
            memberCode = item.split('=')[1];
          }
        });

        // eslint-disable-next-line
        gtag('config', process.env.VUE_APP_GA_TRACK_ID, {
          page_path: to.fullPath,
          send_page_view: true,
          page: '地圖趣',
          obj_category: '地圖趣活動頁',
          action: '進入地圖趣活動',
          item_id: process.env.VUE_APP_PROJECTCODE,
          item_name: mapName.value,
          user_id: memberCode,
          cno: memberCode,
        });
      }
    }
  }, 1000);
});
